module.exports = __webpack_public_path__ + "img/PL09065.13a60e99.png";